import {useTranslation} from 'react-i18next';

import WcOutlinedIcon from '@mui/icons-material/WcOutlined';

import {DistributionBarItem, PercentageDistributionBars} from './PercentageDistributionBars';
import {surveyStatisticBars} from './SurveyStatisticBars.colors';
import {convertDataCountToPercentages} from '../../../../../../../utils/convertDataCountToPercentages/convertDataCountToPercentages';
import {Survey} from '../../../types/SurveyTypes';

interface Props {
  survey: Survey | undefined;
  isOmitted?: boolean;
}

export const GenderDistributionBars = ({survey, isOmitted}: Props) => {
  const {t} = useTranslation();
  const isGenderOmitted = isOmitted ?? Boolean(survey?.configuration?.omitGender);

  const getItems = (): DistributionBarItem[] => {
    const statistics = survey?.statistics;
    if (!statistics) {
      return [];
    }

    const percentages = convertDataCountToPercentages({
      male: statistics.respondentsPerGender.masculine || 0,
      female: statistics.respondentsPerGender.feminine || 0,
      diverse: statistics.respondentsPerGender.diverse || 0,
      notInformed: statistics.respondentsPerGender.preferNotToSay || 0,
    });

    return [
      {
        label: t('companySurveys.details.male'),
        percentage: percentages.male,
        color: surveyStatisticBars.gender.masculine,
      },
      {
        label: t('companySurveys.details.female'),
        percentage: percentages.female,
        color: surveyStatisticBars.gender.feminine,
      },
      {
        label: t('companySurveys.details.diverse'),
        percentage: percentages.diverse,
        color: surveyStatisticBars.gender.diverse,
      },
      {
        label: t('companySurveys.details.notInformed'),
        percentage: percentages.notInformed,
        color: surveyStatisticBars.gender.preferNotToSay,
      },
    ];
  };

  return (
    <PercentageDistributionBars
      title={t('companySurveys.details.gender')}
      icon={<WcOutlinedIcon sx={{fontSize: 14}} />}
      items={getItems()}
      isOmitted={isGenderOmitted}
    />
  );
};
